<div class="container-sm px-alt-3 main-container">
    <app-tag-base [tagType]="'CUSTOMER'"></app-tag-base>
</div>